export enum RoleEnum {
  ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_DEV = 'ROLE_DEV',
  ROLE_LOCAL = 'ROLE_LOCAL',
  ROLE_VIDEO_VALIDATE = 'ROLE_VIDEO_VALIDATE',
  ROLE_USER_VALIDATE = 'ROLE_USER_VALIDATE',
  ROLE_PRG_EDIT = 'ROLE_PRG_EDIT',
  ROLE_VIDEO_ADD = 'ROLE_VIDEO_ADD',
  ROLE_READ = 'ROLE_READ',
}
